const Configuration = (() => {
    const dev = {
        API: "https://admin-bo-api.apiusoft.com/api",
        API_KS:"https://srv-prod-ks.apiusoft.com/admin-bo/api",
        ASSETS: "https://assets-usoft.universalsoft.net",
        APIUSERS: "https://casino-stage.apiusoft.com", 
        GATEWAYAPI: "https://api-test.usoft-api88.net/free-spin",
        //GATEWAYAPI: "https://ms-test.apiusoft.com/free-spin",
        AGREGATORAPI:"https://srv-prod.apiusoft.com",
        ADMI_BO: "https://srv-prod.usoft-api88.net/admin-bo/api"
        
    }
    const local = {
        API: "https://admin-bo-api.apiusoft.com/api",
        API_KS:"https://srv-prod-ks.apiusoft.com/admin-bo/api",
        //GATEWAYAPI: "https://ms-test.apiusoft.com/free-spin",
        GATEWAYAPI: "https://api-test.usoft-api88.net/free-spin",
        //GATEWAYAPI: "http://localhost:5000",
        ASSETS: "https://assets-usoft.universalsoft.net",
        APIUSERS: "https://casino-stage.apiusoft.com", 
        AGREGATORAPI:"https://srv-prod.apiusoft.com",
        ADMI_BO: "https://srv-prod.usoft-api88.net/admin-bo/api"
    }
    const prod = {
        API: "https://admin-bo-api.apiusoft.com/api",
        API_KS:"https://srv-prod-ks.apiusoft.com/admin-bo/api",
        ASSETS: "https://assets-usoft.universalsoft.net",
        APIUSERS: "https://casino-stage.apiusoft.com", 
        //GATEWAYAPI: "https://ms-test.apiusoft.com/free-spin",
        GATEWAYAPI: "https://srv-prod.usoft-api88.net/freespin",
        AGREGATORAPI:"https://srv-prod.apiusoft.com",
        ADMI_BO: "https://srv-prod.usoft-api88.net/admin-bo/api"
    }

    const configMap = new Map()
    configMap.set("local", local)
    configMap.set("dev", dev)
    configMap.set("prod", prod)


    const getEnv = () => {
        const host = window.location.hostname;
        const env = /localhost|127.0.0.1/.test(host) ? 'local' : (/dev/.test(host) || /staging/.test(host)) ? 'dev' : 'prod';
        console.log("YOU ARE ON "+env);
        return env;
    }

    const getConfiguration = () => {
        const env = getEnv()
        const config = configMap.get(env)
        return config
    }
    return { getConfiguration, getEnv }
})()

export default Configuration